<template>
  <div>
    <!-- 用于渲染普通富文本内容 -->
    <div class="rich-content" v-html="processedHtml" @click="handleLinkClick"></div>

    <!-- 用于渲染微信开放标签 -->
    <div v-html="openTagHtml" v-if="isWeChat"></div>
  </div>
</template>

<script>
function isWeixin() {
  const ua = window.navigator.userAgent.toLowerCase();
  return /micromessenger\/[0-9]/i.test(ua); // 匹配 'micromessenger/版本号'
}

export default {
  data() {
    return {
      editorContent: `
        <p>联系方式：
          <a href="weapp://wx123456789/pages/contact?id=123">客服小程序</a>
        </p>
        <p><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);"> </span><a href="https://www.baidu.com/" target="_blank">百度地址：</a> <span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">中国和越南，山水相连，命运与共。建交75年来，在争取国家独立和民族解放的峥嵘岁月中，双方并肩战斗、相互支持，“越中情谊深、同志加兄弟”成为两党两国关系最生动的写照。</span></p><p><span style="color: rgb(34, 34, 34); background-color: rgb(255, 255, 255);">小程序跳转 </span><a href="/pages/index/index" target="_blank">内敛地址</a> </p><p> <img src="https://llss-file.langsounds.com/activity/b170e0a2cd864227a392ab334d25302b.jpg" alt="" data-href="" style=""/></p><div data-w-e-type="video" data-w-e-is-void>
<video poster="" controls="true" width="auto" height="auto"><source src="https://www.runoob.com/try/demo_source/movie.mp4" type="video/mp4"/></video>
</div><p><br></p>`,
      isWeChat: false
    }
  },
  computed: {
    processedHtml() {
      // 非微信环境下保持原样，微信环境下移除小程序链接
      if (this.isWeChat) {
        return this.editorContent.replace(
          /<a href="weapp:\/\/[^"]+">([^<]+)<\/a>/g,
          '<a href="javascript:;" class="weapp-link">$1</a>'
        );
      }
      return this.editorContent;
    },
    openTagHtml() {
      // 只在微信环境下生成开放标签
      if (!this.isWeChat) return '';

      let html = this.editorContent;
      const regex = /<a href="(weapp:\/\/([^/]+)\/([^"]+))">([^<]+)<\/a>/g;

      return html.replace(regex, (match, url, appId, path, text) => {
        return `
          <wx-open-launch-weapp
            username="${appId}"
            path="/${path.replace('?', '&')}"
            style="display: inline-block;"
          >
            <template>
              <a href="javascript:;" style="color: #07C160; text-decoration: underline;">
                ${text}878
              </a>
            </template>
          </wx-open-launch-weapp>
        `;
      });
    }
  },
  methods: {
    handleLinkClick(event) {
      // 检查点击的是否是a标签
      const link = event.target.closest('a');
      console.log(link.getAttribute('href'))
      const href = link?.getAttribute('href');
      // 拦截小程序跳转链接做处理
      if (link && href.startsWith('/pages/')) {
        event.preventDefault(); // 阻止默认跳转行为
        // 执行自定义操作
        this.customLinkAction(href);
      }
    },
    customLinkAction(href) {
      // 你的自定义逻辑
      console.log('点击了链接:', href);
      // 例如：路由跳转、弹窗、数据分析等
      // this.$router.push(...)
      window.open('https://www.baidu.com/', '_blank')
    },
    handleLinkClick(e) {
      const link = e.target.closest('a.weapp-link');
      console.log('---------????????', link)
      if (link && !this.isWeChat) {
        e.preventDefault();
        alert('请在微信内访问以打开小程序');
      }
    },
    checkWeChat() {
      this.isWeChat = isWeixin();
      if (this.isWeChat) {
        initWxConfig();
      }
    }
  },
  mounted() {
    this.checkWeChat();
  }
}
</script>